const FEE_CHANGE_REQUEST_FIELDS = `
  __typename
  ... on ExhibitorFeeChangeRequest {
    id
    exhibitor_id
    tenant_id
    status_id
    pay
    pay_virtual
    pay_virtual_short
    description
    decision_message
    decision_date
    created_by
    its
    uts
    status {
      id
      name
      translation_key
      hex_color
    }
    exhibitor_fee_change_request_log {
      id
      old_status { id name translation_key hex_color }
      new_status { id name translation_key hex_color }
      message
      its
    }
  }
  ... on ResultError {
    status_code
    message
    message_translation_key
  }
`;

export const CREATE_EXHIBITOR_FEE_CHANGE_REQUEST = `
  mutation createExhibitorFeeChangeRequest($input: CreateExhibitorFeeChangeRequestInput!, $tenant_id: Int!) {
    createExhibitorFeeChangeRequest(input: $input, tenant_id: $tenant_id) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;

export const APPROVE_EXHIBITOR_FEE_CHANGE_REQUEST = `
  mutation approveExhibitorFeeChangeRequest($input: DecideExhibitorFeeChangeRequestInput!, $tenant_id: Int!) {
    approveExhibitorFeeChangeRequest(input: $input, tenant_id: $tenant_id) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;

export const REJECT_EXHIBITOR_FEE_CHANGE_REQUEST = `
  mutation rejectExhibitorFeeChangeRequest($input: DecideExhibitorFeeChangeRequestInput!, $tenant_id: Int!) {
    rejectExhibitorFeeChangeRequest(input: $input, tenant_id: $tenant_id) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;

export const CANCEL_EXHIBITOR_FEE_CHANGE_REQUEST = `
  mutation cancelExhibitorFeeChangeRequest($input: DecideExhibitorFeeChangeRequestInput!, $tenant_id: Int!) {
    cancelExhibitorFeeChangeRequest(input: $input, tenant_id: $tenant_id) {
      ${FEE_CHANGE_REQUEST_FIELDS}
    }
  }
`;
